import React from 'react'
import { navigate } from 'gatsby'

import FontAwesome from 'components/FontAwesome'
import Button from 'components/Button'

import { StyledPagination } from './styles'

function Pagination({ data, path }) {
   const urlPrefix = data.isBlog ? 'blog/' : ''

   function goToNextPage() {
      const url =
         data.currentPage === 1
            ? `${path}${urlPrefix}page-${data.currentPage + 1}/`
            : path.replace(`page-${data.currentPage}/`, `page-${data.currentPage + 1}/`)
      navigate(url)
   }

   function goToPrevPage() {
      const url = `${
         data.currentPage - 1 > 1
            ? path.replace(`page-${data.currentPage}/`, `page-${data.currentPage - 1}/`)
            : path.replace(`${urlPrefix}page-${data.currentPage}/`, '')
      }`
      navigate(url)
   }

   return (
      <StyledPagination>
         <Button small disabled={!data.hasPreviousPage} onClick={goToPrevPage}>
            <FontAwesome icon={'arrowLeft'} />
            Prev
         </Button>
         <span>
            Page {data.currentPage} from {data.pageCount}
         </span>
         <Button small disabled={!data.hasNextPage} onClick={goToNextPage}>
            Next
            <FontAwesome icon={'arrowRight'} style={{ marginLeft: 11, marginRight: 0 }} />
         </Button>
      </StyledPagination>
   )
}

export default Pagination
